export default "/assets/images/download-mila-app.62ae196d4800c0b8.png";